<template>
  <div class="paginator">
    <div
      v-if="totalPages > 0"
      class="paginator-page-counter pull-left"
    >{{$t("app.pagination.total_pages_counter",{total_pages: totalPages})}}</div>
    <div class="paginator-items pull-right">
      <span
        v-for="(pageIndex, index) in pageIndexes"
        :key="index"
        :class="classesForItem(pageIndex)"
        @click="selectItem(pageIndex)"
      >{{pageIndex}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginator",
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPageIndex: {
      type: Number,
      required: true
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    pageIndexes() {
      return Array.from(new Array(this.totalPages), (val, index) => index + 1);
    }
  },
  mounted() {},
  methods: {
    classesForItem(index) {
      return `paginator-item ${
        index === this.currentPageIndex ? "selected" : ""
      }`;
    },
    selectItem(index) {
      if (index === this.currentPageIndex) {
        return;
      }
      this.$emit("itemSelected", index);
    }
  }
};
</script>

<style lang="scss">
.paginator {
  overflow: hidden;
  .paginator-page-counter {
    padding: 0.5em 1em;
  }
  .paginator-item {
    box-sizing: border-box;
    display: inline-block;
    min-width: 1.5em;
    padding: 0.5em 1em;
    margin-left: 2px;
    text-align: center;
    text-decoration: none !important;
    cursor: pointer;
    *cursor: hand;
    color: #333 !important;
    border: 1px solid transparent;
    border-radius: 2px;
    &.selected,
    &:hover {
      background: var(--main-color);
      border-color: var(--main-color);
      color: #fff !important;
      box-shadow: none;
      border-radius: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/navigations/Paginator.vue